export default ">> **To integrate Taiga with LambdaTest, the user should have the necessary privileges to create issues**";